module.exports = "<p>\n  report-display-heatmap works!\n</p>\n"